import { IsVisibleOnFormBaseValueConverter } from 'General/Resources/ValueConverters/IsVisibleOnFormBase';

export class IsVisibleOnFormValueConverter extends IsVisibleOnFormBaseValueConverter {

}